import React from 'react';
import Img from "../../images/services/ar-vr/custom.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Your Choice Of Augmented Reality And Virtual Reality Solution Companies</h2>
                        <p>TekRevol is among those AR solution companies to help startups and enterprises employ the
                            real potential of mixed reality technology and deliver immersive user experiences. Our
                            development experts use multiple mobile development technologies, including Swift,
                            Objective-C, Xcode, and more tailored to the client’s technical requirements and vision.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;